import app from '../main'

export const show = () => {
  app.$Progress.start()
}

export const hide = () => {
  app.$Progress.finish()
}

export default { show, hide }
